export default __webpack_public_path__ + "d63b5168a056826cc96eb9527eba81db.svg";